import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import { GetUsersResponse, User } from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PASS_URL = `${API_URL}/pass`
const USER_URL = `${API_URL}/user`

const getUsers = (page: number, limit: number, query?: string): Promise<GetUsersResponse> => {
  const params = { page, limit, nome: query, email: query, username: query }

  return axios.get(`${USER_URL}`, { params }).then((d: AxiosResponse<GetUsersResponse>) => d.data)
}

const createUser = (menu: User): Promise<User> => {
  return axios.post(`${USER_URL}`, menu).then((d: AxiosResponse<User>) => d.data)
}

const updateUser = (menu: User): Promise<User> => {
  return axios.patch(`${USER_URL}/${menu.id}`, menu).then((d: AxiosResponse<User>) => d.data)
}

const deleteUser = (id: ID): Promise<User> => {
  return axios.delete(`${USER_URL}/${id}`).then((d: AxiosResponse<User>) => d.data)
}

const getUserById = (id: ID): Promise<User> => {
  return axios.get(`${USER_URL}/${id}`).then((d: AxiosResponse<User>) => d.data)
}

const createPass = (idUsuario: string, senha: string): Promise<{ errors: string; code: Number }> => {
  return axios.post(PASS_URL, { idUsuario, senha }).then((d: AxiosResponse) => d.data)
}

export { getUsers, createUser, updateUser, deleteUser, getUserById, createPass }
